import { useState } from 'react';

export const useResetOnChange = (key: unknown, reset: () => void): void => {
  const [prev, setPrev] = useState(key);
  if (prev !== key) {
    setPrev(key);
    reset();
  }
};
